import { authHeader } from '../_core/auth-header';
import Config from '../_core/config';

export const menuService = {
    getAll,
    create,
    remove,
    update,
    getById,
    getDefault,
    addItem,
    updateItem,
    getMenuByName,
    removeItem
};

function create(body) {
    const user = JSON.parse(localStorage.getItem('user'));
    body.createdBy = user.user._id;
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(body)
    };

    return fetch(Config.api.basepath + "/menu", requestOptions).then(handleResponse);
}

function update(body) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(body)
    };

    return fetch(Config.api.basepath+`/menu/`+body._id, requestOptions).then(handleResponse);
}

function getAll(options) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    let url = Config.api.basepath+`/menu?`;

    url = options.page ? url + `page=` + options.page : url
    url = options.items ? url + `&per-page=` + options.items : url
    url = options.limit ? url + `&limit=` + options.limit : url;

    let filter = options.filter && Object.keys(options.filter).reduce(function (r, k) {
        return r.concat(k + ':' + options.filter[k]);
    }, []);

    url = options.filter ? url + `&filter=` + filter : url;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(
            menus => {
                let pages = parseInt(menus.total / menus['per-page']);
                pages = menus.total > ( pages * menus['per-page'] ) ? pages + 1 : pages;

                menus.pages = pages;

                return menus;
            },
            error => {
                return {error: 'Fetch Menu Error. Service Unavailable.'};
            }
        );
}

function getById(menu_id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/menu/`+menu_id, requestOptions)
        .then(handleResponse)
        .then(
            menus => {
                
                return menus.items;
            },
            error => {
                return {error: 'Fetch Menu Error. Service Unavailable.'};
            }
        );
}

function getDefault() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(Config.api.basepath+`/menu/default`, requestOptions)
        .then(handleResponse)
        .then(
            menus => {
                menus.items.sort((a, b) => (a.position > b.position) ? 1 : -1);
                return menus;
            },
            error => {
                return {error: 'Fetch Menu Error. Service Unavailable.'};
            }
        );
}

function getMenuByName(menuname) {

    // Fetch menu by name from WordPress API
    return fetch(Config.api.basepath + '/menus/v1/menus')
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(menus => {
            // Find the menu by name
            const foundMenu = menus.find(menu => menu.name === menuname);
            if (!foundMenu) {
                throw new Error('Menu not found');
            }
            // Fetch menu items for the found menu
            return fetch(Config.api.basepath + `/menus/v1/menus/${foundMenu.slug}`).then(handleResponse)
        })
        .catch(error => {
            console.error('Error fetching menu:', error);
            throw error;
        });
}


function remove(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/menu/`+id, requestOptions).then(handleResponse);
}

function addItem(menu_id, body) {
    
    const user = JSON.parse(localStorage.getItem('user'))

    body.createdBy = user.user._id;

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(body)
    };

    return fetch(Config.api.basepath+`/menu/`+menu_id+`/item`, requestOptions).then(handleResponse)
}

function updateItem(menu_id, body) {
    
    const user = JSON.parse(localStorage.getItem('user'))
    body.createdBy = user.user._id;

    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(body)
    };

    return fetch(Config.api.basepath+`/menu/`+menu_id+`/item/${body._id}`, requestOptions).then(handleResponse)
}

function removeItem(menu_id, item_id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/menu/${menu_id}/item/${item_id}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            let error = (data.error && data.error.message) || response.statusText;

            if( data.error && data.error.code === 11000){
                error = 'Menu already exists.';
            }
            
            return Promise.reject(error);
        }

        return data;
    });
}
